export const LEGACY_PATHS = ["/progetti-benefit", "/easytrasporto", "/manuale/easytrasporto", "/fabbisogno-formativo", "/area-riservata", "/registro-benefit"];

export const isLegacyPath = (path) => LEGACY_PATHS.some((p) => path.startsWith(p));

const SUITE_TINT = { "#2563EB": "#1B2380", "#1D4ED8": "#1B2380", "#4F46E5": "#1B2380", "#10B981": "#0E8C84", "#F97316": "#F39200" };

export const suiteColor = (c) => SUITE_TINT[(c || "").toUpperCase()] || c;
